<template>
    <cod-dialog
        ref="dialog"
        :show.sync="showDialog"
        max-width="520px"
        back-icon="fal fa-arrow-left"
    >
        <!-- Header -->
        <div slot="header" class="header">
            <div>{{ $tc('general.user', 2) }}</div>
        </div>

        <!-- Content -->
        <div slot="content" class="select-user-content">

            <v-alert
                class="ma-4"
                prominent
                type="info"
                text
            >
                {{ message }}
            </v-alert>

            <v-divider />

            <v-list class="pa-0">
                <template v-for="(user, index) in users">

                    <v-list-item
                        :id="`user-${index}`"
                        :key="index"
                        :class="{item: true, selected: selectedUser && selectedUser.id === user.id}"
                        @click="selectedUser = user"
                    >
                        <v-list-item-content>
                            <v-list-item-title class="d-flex align-center">
                                {{ user.name }}
                            </v-list-item-title>
                        </v-list-item-content>

                        <v-list-item-icon class="ma-3">
                            <v-scale-transition hide-on-leave>
                                <v-icon
                                    v-if="selectedUser && selectedUser.id === user.id"
                                    :size="24"
                                    color="success"
                                >
                                    far fa-check
                                </v-icon>
                            </v-scale-transition>
                        </v-list-item-icon>

                    </v-list-item>

                    <v-divider :key="`${index}-divider`" />

                </template>
            </v-list>
        </div>

        <!-- Footer -->
        <v-row
            slot="footer"
            class="select-user-footer"
            justify="space-between"
        >
            <v-btn
                class="flex-1 mr-1"
                color="primary"
                outlined
                @click="showDialog = false"
            >
                {{ $t('general.close') }}
            </v-btn>

            <v-btn
                class="flex-1 ml-1"
                color="primary"
                depressed
                :disabled="!selectedUser"
                @click="select"
            >
                {{ $t('general.confirm') }}
            </v-btn>
        </v-row>
    </cod-dialog>
</template>

<script>
import CodDialog from '@/components/CodDialog';
import User from '@/models/User';

export default {
    components: {
        CodDialog,
    },

    props: {
        show: {
            type: Boolean,
            default: false
        },
        message: {
            type: String,
            default: null
        },
    },

    data: () => ({
        showDialog: false,
        selectedUser: null,
        users: []
    }),

    watch: {
        show(val) {
            this.showDialog = val;
            this.selectedUser = null;
            this.users = User.all().filter(user => user.id !== this.user.id);
        },

        showDialog(val) {
            this.$emit('update:show', val);
        }
    },

    methods: {
        select() {
            this.showDialog = false;
            this.$emit('select', this.selectedUser);
        },
    }
};
</script>

<style lang="scss" scoped>
.header {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.select-user-content {
    min-height: 400px;
}

.select-user-footer {
    padding: 16px;
}
</style>
